import { render, staticRenderFns } from "./StartupInfo.vue?vue&type=template&id=e54e35c2&scoped=true"
import script from "./StartupInfo.vue?vue&type=script&lang=js"
export * from "./StartupInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54e35c2",
  null
  
)

export default component.exports